import Swiper, { Pagination, Navigation, Autoplay } from 'swiper'

const contentSliderInstances = [];
const contentSliderElements = document.querySelectorAll('.testimonial-slider');

if (contentSliderElements.length) {
    for (let i = 0; i < contentSliderElements.length; i++) {
        contentSliderInstances[i] = {
            init: false,
            instance: null,
            element: contentSliderElements[i],
        };
    }
}

function contentSlidersInit() {
    if (contentSliderInstances.length === 0) {
        return
    }

    for (let i = 0; i < contentSliderElements.length; i++) {
        if (! contentSliderInstances[i].init) {
            contentSliderInstances[i].init = true;

            contentSliderInstances[i].instance = initializeContentSlider(contentSliderInstances[i].element, i % 2 === 0);
        }
    }
}
contentSlidersInit();
window.addEventListener('resize', contentSlidersInit);

function initializeContentSlider(slider) {
    return new Swiper(slider, {
        modules: [ Pagination, Navigation, Autoplay ],
        spaceBetween: 20,
        speed: 700,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        pagination: {
            el: '.swiper-pagination, .swiper-pagination-custom',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1440: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });
}
